import { Component } from '@angular/core';
import { ModalController,NavController, NavParams,LoadingController } from 'ionic-angular';
import {DriverServiceProvider} from '../../../../providers/dvm/driver-service';


@Component({
  selector: 'page-list',
  templateUrl: 'index.html',
  providers: [DriverServiceProvider]
})
export class ClientListPage {
 header_data:any;

  icons: string[];
  items: Array<{title: string, note: string, icon: string}>;

  public drivers_list: any;

  constructor(public modalCtrl: ModalController,public navCtrl: NavController, public navParams: NavParams,public driverService: DriverServiceProvider,public loadingCtrl: LoadingController) {
    this.header_data={ismenu:true,ishome:false,title:"Clients List"};
    this.loadClients();
  }

  
      loadClients(){



  let loader = this.loadingCtrl.create({
      content: "Please wait..."
    });
    loader.present();



        this.driverService.load_driver_list_by_client()
        .then(data => {
          this.drivers_list = data;
        });
        loader.dismiss();
      }
  



changeDriver(a,i){
  console.log(a);
 // a.parentPage=this;

   let profileModal = this.modalCtrl.create('DriverPageModel', a);
   profileModal.present();

}






}



// WEBPACK FOOTER //
// ./src/pages/dvm/clients/list/index.ts